import { TypeKeys, ActionTypes } from '../actions/index';

const getInitialState = (): CustomWorkoutsState => {
  return {
    customEditWorkoutsById: {},
    customWorkoutsLoaded: false,
    sortedCustomWorkoutIds: [],
  };
};

const customWorkouts = (
  state: CustomWorkoutsState = getInitialState(),
  action: ActionTypes
): CustomWorkoutsState => {
  switch (action.type) {
    case TypeKeys.SET_CUSTOM_EDIT_WORKOUTS: {
      const customEditWorkoutsById = {};
      const sortedCustomWorkoutIds = [];
      action.customWorkouts
        .sort((a, b) => {
          if (b.order) {
            return b.order > a.order ? -1 : 1;
          } else if (a.id > b.id) {
            return -1;
          } else {
            return 1;
          }
        })
        .map((customWorkout) => {
          customEditWorkoutsById[customWorkout.id] = customWorkout;
          sortedCustomWorkoutIds.push(customWorkout.id);
        });

      return {
        ...state,
        customEditWorkoutsById,
        customWorkoutsLoaded: true,
        sortedCustomWorkoutIds,
      };
    }
    case TypeKeys.SIGN_OUT: {
      return { ...getInitialState() };
    }
  }
  return state;
};

export default customWorkouts;
